import React from 'react';
import { Button, MediaMatch, Typography, useViewport } from '@lamimed/pantheon';
import Image from 'next/legacy/image';
import Link from 'next/link';

import * as S from './styles';

interface CallToActionProps {
  title: string;
  description: string;
  buttonText: string;
  slug: string;
}

const DynamicWrapper: React.FC<
  React.PropsWithChildren<Partial<CallToActionProps>>
> = ({ slug, children }) => {
  const { greaterThan } = useViewport();

  if (greaterThan('tablet')) {
    return <>{children}</>;
  }

  return (
    <Link href={`/telemedicina/${slug}`} passHref legacyBehavior>
      <S.LinkProxy>{children}</S.LinkProxy>
    </Link>
  );
};

export const CallToAction: React.FC<CallToActionProps> = ({
  title,
  description,
  buttonText,
  slug,
}) => {
  return (
    <S.Wrapper variant="default" color="gradient__primary">
      <MediaMatch greaterThan="tablet">
        <S.Divider position="above" />

        <S.WaterMarkWrapper variant="bottom">
          <Image
            src="/images/illustration/water-mark.svg"
            width={423}
            height={393}
            quality={100}
          />
        </S.WaterMarkWrapper>

        <S.WaterMarkWrapper variant="top">
          <Image
            src="/images/illustration/water-mark.svg"
            width={423}
            height={393}
            quality={100}
          />
        </S.WaterMarkWrapper>

        <S.CardThumbnailDivider>
          <Image
            src="/images/illustration/consulto.png"
            width={242}
            height={181}
            quality={100}
          />
        </S.CardThumbnailDivider>
      </MediaMatch>

      <DynamicWrapper slug={slug}>
        <S.Content>
          <MediaMatch lessThan="tablet">
            <Typography variant="heading_2" color="text__light">
              {title}
            </Typography>
          </MediaMatch>

          <MediaMatch greaterThan="tablet">
            <Typography variant="heading_1" color="text__light">
              {title}
            </Typography>
          </MediaMatch>

          <Typography color="text__light">{description}</Typography>

          <MediaMatch lessThan="tablet">
            <S.ImageWrapper>
              <Image
                src="/images/illustration/consulto.png"
                width={160}
                height={120}
                quality={100}
              />
            </S.ImageWrapper>
          </MediaMatch>

          <MediaMatch greaterThan="tablet">
            <Link href={`/telemedicina/${slug}`} passHref legacyBehavior>
              <S.LinkProxy>
                <Button
                  variant="overlay"
                  size="large"
                  color="primary"
                  data-tracking-id="video-visita"
                  extended
                >
                  {buttonText}
                </Button>
              </S.LinkProxy>
            </Link>
          </MediaMatch>
        </S.Content>
      </DynamicWrapper>
    </S.Wrapper>
  );
};
